import { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'

import { MINTTOKEN } from '../../constants/bakery'

const useBlockNum = (currentBlock: number, tokenName?: string) => {
  const [blockNum, setBlockNum] = useState<BigNumber>()

  const startBlock = 475805
  const bakeStartBlock = 400
  const bakeBonusEndBlock = 110
  const bonusBeforeCommonDifference = 10
  const bonusEndCommonDifference = 10
  const maxRewardBlockNumber = 11275805
  const maxPetRewardBlockNumber = 11275805
  useEffect(() => {
    if (currentBlock !== 0) {
      let num = new BigNumber(currentBlock).gt(maxRewardBlockNumber)
        ? new BigNumber(0)
        : new BigNumber(currentBlock).minus(startBlock).lt(900000)
        ? new BigNumber(bakeStartBlock).minus(
            BigNumber.maximum(
              1,
              new BigNumber(currentBlock)
                .minus(startBlock)
                .dividedBy(30000)
                .toFixed(0, BigNumber.ROUND_UP)
            )
              .minus(1)
              .multipliedBy(bonusBeforeCommonDifference)
          )
        : new BigNumber(bakeBonusEndBlock).minus(
            BigNumber.maximum(
              1,
              new BigNumber(currentBlock)
                .minus(startBlock)
                .dividedBy(900000)
                .toFixed(0, BigNumber.ROUND_UP)
            )
              .minus(1)
              .multipliedBy(bonusEndCommonDifference)
          )
      // eslint-disable-next-line
      switch (tokenName) {
        case MINTTOKEN.PET:
          num = new BigNumber(currentBlock).gt(maxPetRewardBlockNumber) ? new BigNumber(0) : new BigNumber(0.4)
          break
        case MINTTOKEN.BPET:
          num = new BigNumber(currentBlock).gt(maxPetRewardBlockNumber) ? new BigNumber(0) : new BigNumber(0.4)
          break
        case MINTTOKEN.BEST:
          num = new BigNumber(currentBlock).gt(maxPetRewardBlockNumber) ? new BigNumber(0) : new BigNumber(0.4)
      }
      setBlockNum(num)
    }
  }, [currentBlock, tokenName])

  return blockNum
}

export default useBlockNum
